import { render, staticRenderFns } from "./FormInputSplitDateTime.vue?vue&type=template&id=bd1a073c&scoped=true&lang=pug"
import script from "./FormInputSplitDateTime.vue?vue&type=script&lang=ts"
export * from "./FormInputSplitDateTime.vue?vue&type=script&lang=ts"
import style0 from "./FormInputSplitDateTime.vue?vue&type=style&index=0&id=bd1a073c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a073c",
  null
  
)

export default component.exports